import type { SeatsStateDTO } from "../data/seatsApi";

/**
 * The workspace preview's "review load" summary — written by the team screen
 * after every seats/policy change (the teamAccess pattern) so the right rail
 * and the go-live summary can render it without re-reading the tabs.
 *
 * This file once held the approval-rules screen's packages and four-value
 * vocabulary; the module-wise maker–checker screen replaced all of that, and
 * the preview is now derived from the seats state's three-state policies.
 */
export const APPROVALS_PREVIEW_KEY = "approvalRules";

export interface ApprovalsPreview {
  /** Kept for stored answers written before the seats screen; always true now. */
  chosen: boolean;
  packageLabel: string;
  /**
   * Legacy key names, current meanings: posts_directly = post,
   * needs_approval = review, not_allowed = blocked (Checker-only). cfo_only is
   * dead — it stays only so answers persisted by the old screen still parse.
   */
  counts: Record<"posts_directly" | "needs_approval" | "not_allowed" | "cfo_only", number>;
  /** How many functions land in a Checker's review queue. */
  queue: number;
}

export function seatsToApprovalsPreview(state: SeatsStateDTO): ApprovalsPreview {
  let post = 0;
  let review = 0;
  let blocked = 0;
  let changed = 0;
  for (const tab of state.tabs) {
    post += tab.counts.post;
    review += tab.counts.review;
    blocked += tab.counts.blocked;
    changed += tab.changed_count;
  }

  return {
    chosen: true,
    packageLabel: changed > 0 ? "Firm defaults, customised" : "Firm defaults",
    counts: { posts_directly: post, needs_approval: review, not_allowed: blocked, cfo_only: 0 },
    queue: review,
  };
}
